"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var list_1 = require("@material/list");
var ripple_1 = require("@material/ripple");
var dom_ready_1 = require("../util/dom-ready");
//@ts-ignore
require("../theme.ts");
var List = /** @class */ (function (_super) {
    __extends(List, _super);
    function List() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    List.prototype.installed = function () {
        var _this = this;
        dom_ready_1.domReady(function () {
            //init mdc list
            var lists = _this.shadowRoot.querySelectorAll('.mdc-list');
            lists.forEach(function (list, index) {
                var listControl = new list_1.MDCList(list);
                listControl.listElements.map(function (listItemEl) { return new ripple_1.MDCRipple(listItemEl); });
                listControl.singleSelection = _this.props.singleSelection;
                listControl.listen('MDCList:action', function (evt) {
                    _this.fire('itemclick', { item: _this.props.items[evt.detail.index], index: evt.detail.index });
                    // if(this.listAll[index][evt.detail.index]) {
                    //   this.fire('change', this.listAll[index][evt.detail.index])
                    // } else {
                    //   this.fire('change', this.listAll[index+1][evt.detail.index])
                    // }
                });
            });
        });
    };
    List.prototype._renderCheckbox = function (props, item) {
        if (props.checkbox) {
            return omi_1.h("div", { class: "mdc-checkbox mdc-list-item__meta mdc-checkbox--upgraded mdc-ripple-upgraded mdc-ripple-upgraded--unbounded", style: "--mdc-ripple-fg-size:24px; --mdc-ripple-fg-scale:1.66667; --mdc-ripple-left:8px; --mdc-ripple-top:8px;" },
                omi_1.h("input", { type: "checkbox", class: "mdc-checkbox__native-control", "aria-labelledby": "2c7710a7-dda2-45e4-b64b-3144fca2bb32", checked: item.checked, tabindex: "-1" }),
                omi_1.h("div", { class: "mdc-checkbox__background" },
                    omi_1.h("svg", { class: "mdc-checkbox__checkmark", viewBox: "0 0 24 24" },
                        omi_1.h("path", { class: "mdc-checkbox__checkmark-path", fill: "none", stroke: "white", d: "M1.73,12.91 8.1,19.28 22.79,4.59" })),
                    omi_1.h("div", { class: "mdc-checkbox__mixedmark" })));
        }
    };
    List.prototype._renderRadio = function (props, item) {
        if (props.radio) {
            return omi_1.h("div", { class: "mdc-radio mdc-list-item__meta mdc-ripple-upgraded mdc-ripple-upgraded--unbounded", style: "--mdc-ripple-fg-size:24px; --mdc-ripple-fg-scale:1.66667; --mdc-ripple-left:8px; --mdc-ripple-top:8px;" },
                omi_1.h("input", { class: "mdc-radio__native-control", type: "radio", name: "listRadioGroup", "aria-labelledby": "1ad8870d-6eb4-4710-bfb6-a295ddc0f64c", checked: item.checked, tabindex: "-1" }),
                omi_1.h("div", { class: "mdc-radio__background" },
                    omi_1.h("div", { class: "mdc-radio__outer-circle" }),
                    omi_1.h("div", { class: "mdc-radio__inner-circle" })));
        }
    };
    List.prototype.render = function (props) {
        var _this = this;
        var style = {};
        var hasStyle = false;
        if (props.width) {
            hasStyle = true;
            style.width = props.width + 'px';
        }
        if (props.height) {
            hasStyle = true;
            style.height = props.height + 'px';
        }
        return omi_1.h("ul", __assign({}, (hasStyle ? { style: style } : {}), omi_1.extractClass(props, 'mdc-list', {
            'mdc-list--two-line': props.items[0] ? props.items[0].secondaryText : '',
            'mdc-list--crl': props.radioLeft || props.checkboxLeft
        })), props.items.map(function (item) {
            if (item.divider || item === true) {
                return omi_1.h("li", { role: "separator", class: "mdc-list-divider" });
            }
            return omi_1.h("li", { class: omi_1.classNames('mdc-list-item', {
                    'mdc-list-item--selected': item.selected
                }) },
                props.checkboxLeft && _this._renderCheckbox(props, item),
                props.radioLeft && _this._renderRadio(props, item),
                item.icon && omi_1.h("span", { class: "mdc-list-item__graphic material-icons", "aria-hidden": "true" }, item.icon),
                omi_1.h("span", { class: "mdc-list-item__text" }, item.text ? (item.text && item.secondaryText ? [
                    omi_1.h("span", { class: "mdc-list-item__primary-text" }, item.text),
                    omi_1.h("span", { class: "mdc-list-item__secondary-text" }, item.secondaryText)
                ] : item.text) : item),
                item.rightIcon && omi_1.h("span", { class: "mdc-list-item__graphic mdc-list-item__meta material-icons", "aria-hidden": "true" }, item.rightIcon),
                !props.checkboxLeft && _this._renderCheckbox(props, item),
                !props.radioLeft && _this._renderRadio(props, item));
        }));
    };
    List.css = css;
    List.propTypes = {
        items: Object,
        singleSelection: Boolean,
        checkbox: Boolean,
        radio: Boolean,
        checkboxLeft: Boolean,
        radioLeft: Boolean,
        width: Number,
        height: Number
    };
    List.defaultProps = {};
    List = __decorate([
        omi_1.tag('m-list')
    ], List);
    return List;
}(omi_1.WeElement));
exports.default = List;
